/* Company Profile — helper murni (tanpa React). Ikon Why Us hanya dari allowlist ini (sinkron backend). */
import {
  ShieldCheck, Truck, Award, Clock, Leaf, Star, Users, Heart, BadgeCheck, Package, Sparkles, ThumbsUp,
  Headset, MapPin, Wallet, RefreshCw,
} from "lucide-react";

export const ICON_MAP = {
  "shield-check": ShieldCheck, truck: Truck, award: Award, clock: Clock, leaf: Leaf, star: Star, users: Users,
  heart: Heart, "badge-check": BadgeCheck, package: Package, sparkles: Sparkles, "thumbs-up": ThumbsUp,
  headset: Headset, "map-pin": MapPin, wallet: Wallet, "refresh-cw": RefreshCw,
};
export const ICON_KEYS = Object.keys(ICON_MAP);
export const iconFor = (key) => ICON_MAP[key] || BadgeCheck;

export const SECTION_LABELS = {
  hero: "Hero", about: "Tentang", why_us: "Keunggulan", store_preview: "Pratinjau Toko", business_cta: "Bisnis / Grosir",
  gallery: "Galeri", stats: "Statistik", faq: "FAQ", location: "Lokasi & Kontak",
};
export const SECTION_ANCHORS = { about: "tentang", why_us: "keunggulan", gallery: "galeri", faq: "faq", location: "lokasi" };
const NAV_LABELS = { about: "Tentang", why_us: "Keunggulan", gallery: "Galeri", faq: "FAQ", location: "Lokasi" };
export const DEFAULT_ORDER = ["about", "why_us", "store_preview", "business_cta", "gallery", "stats", "faq", "location"];

export const isExternalUrl = (url) => /^(https?:|mailto:|tel:)/i.test(String(url || ""));
export const isSafeUrl = (url) => /^(https?:\/\/\S+|mailto:\S+|tel:\+?[0-9\-() ]+|\/(?!\/)\S*)$/i.test(String(url || "").trim());

/* Navigasi CP-aware: anchor hanya untuk section yang benar-benar tampil; Toko → /katalog existing. */
export function buildCompanyNav(sectionOrder = [], catalogPath = "/katalog") {
  const items = [{ key: "home", label: "Beranda", to: "/" }];
  for (const key of sectionOrder) {
    const anchor = SECTION_ANCHORS[key];
    if (anchor) items.push({ key, label: NAV_LABELS[key], to: `/#${anchor}`, anchor });
  }
  items.push({ key: "store", label: "Toko", to: catalogPath });
  return items;
}

/* Lokasi: nilai CP prioritas; kosong → fallback branding.contact existing. Semua kosong → null (tidak dirender). */
export function resolveLocation(loc, contact = {}) {
  if (!loc) return null;
  const pick = (a, b) => (String(a || "").trim() ? a : b || "");
  const out = {
    title: loc.title || "",
    address: pick(loc.address, contact.address),
    hours: loc.hours || "",
    phone: loc.phone || "",
    whatsapp: pick(loc.whatsapp, contact.whatsapp),
    email: pick(loc.email, contact.email),
    maps_url: pick(loc.maps_url, contact.maps_url),
  };
  const filled = ["address", "hours", "phone", "whatsapp", "email", "maps_url"].some((k) => String(out[k] || "").trim());
  return filled ? out : null;
}

/* FAQPage JSON-LD hanya bila ada Q/A nyata; kosong → null (tidak emit schema). */
export function faqJsonLd(items) {
  const real = (items || []).filter((it) => String(it?.question || "").trim() && String(it?.answer || "").trim());
  if (!real.length) return null;
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: real.map((it) => ({
      "@type": "Question", name: it.question,
      acceptedAnswer: { "@type": "Answer", text: it.answer },
    })),
  };
}

/* Slot gambar CP — nilai diturunkan dari renderer nyata (CSS .cp-hero-media / .cp-about-media / .cp-gallery-item).
   Satu upload dipakai desktop & mobile: landscape/persegi → cover (fokus tengah), potret (lebar < tinggi) →
   contain + backdrop blur (ambang identik Store Banner GCP: isPortraitSource, rasio < 1.0). */
export const IMAGE_SLOTS = {
  hero: { label: "Hero", ratio: "4 / 3", ratioLabel: "4:3", width: 1200, height: 900, mobile: "Lebar penuh 4:3 di bawah teks" },
  about: { label: "Tentang", ratio: "5 / 4", ratioLabel: "5:4", width: 1000, height: 800, mobile: "Lebar penuh 5:4 di bawah teks" },
  gallery: { label: "Galeri", ratio: "1 / 1", ratioLabel: "1:1", width: 800, height: 800, mobile: "Grid 2 kolom persegi" },
};
export const imageSlotNotes = (slot) => {
  const s = IMAGE_SLOTS[slot];
  return [
    `Rekomendasi: ${s.width} × ${s.height} px (${s.ratioLabel}). PNG/JPG/WebP, maks. 2 MB.`,
    `Satu gambar digunakan untuk desktop & mobile (${s.mobile}). Gambar landscape/persegi dipotong rapi di tengah; gambar potret ditampilkan utuh di atas latar blur.`,
  ];
};

export const PRODUCT_SOURCES = [
  { value: "featured", label: "Produk Unggulan", hint: "Memakai penanda \"Unggulan\" pada editor produk (flag existing)." },
  { value: "manual", label: "Pilih Manual", hint: "Pilih hingga 8 produk dari katalog; urutan mengikuti pilihan Anda." },
  { value: "best_seller", label: "Terlaris", hint: "Memakai penanda \"Terlaris\" pada editor produk (flag existing, sama dengan filter Terlaris di katalog)." },
];
